import { render, staticRenderFns } from "./privacy2.1.vue?vue&type=template&id=0f1e9de0&scoped=true&"
import script from "./privacy2.1.vue?vue&type=script&lang=js&"
export * from "./privacy2.1.vue?vue&type=script&lang=js&"
import style0 from "./privacy2.1.vue?vue&type=style&index=0&id=0f1e9de0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1e9de0",
  null
  
)

export default component.exports